import { render, staticRenderFns } from "./AuditLogDetails.vue?vue&type=template&id=89a6b7cc&"
import script from "./AuditLogDetails.vue?vue&type=script&lang=js&"
export * from "./AuditLogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports